import React from 'react'

export const ErrorIcon: React.FC = () => {
  return (
    <svg
      width="320"
      height="320"
      viewBox="0 0 320 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.856 160.003L276.096 62.7637L257.24 43.9075L160 141.147L62.7605 43.9075L43.9043 62.7637L141.144 160.003L43.9063 257.241L62.7625 276.097L160 178.859L257.238 276.097L276.094 257.241L178.856 160.003Z"
        fill="white"
      />
    </svg>
  )
}

export default ErrorIcon
